import React from 'react';
import TableHeaderRow from "./TableHeaderRow";

function TableHeader({ headers }) {
    return (
        <thead className="sl-bg-gray-50 sl-border sl-rounded-top-lg sl-border-solid sl-border-gray-200">
            <TableHeaderRow headers={headers} />
        </thead>
    );
}

export default TableHeader;
